class refer{
	constructor(formsRefer,shareLinks){
		this.formsRefer=formsRefer;
		this.shareLinks=shareLinks;
	}
	createReferForm(){
		this.renderReferForm(this.formsRefer.newUserForm,this.onNextSubmit);
		this.renderReferForm(this.formsRefer.exictingUserForm,this.onSendSubmit);
	}
	renderReferForm(form,onsubmit){
		$(".refer-form").append(
			$("<form>").addClass(form.formtype).append(
				$("<p>").addClass("refer-form-p").text(form.text),
				$("<div>").addClass("refer-form-input").append(
				$("<input>",{
					type:"text",
					placeholder:form.placeolder
				}),
				$("<input>",{
					type:"submit",
					value:form.submittext
				}))).addClass("hiddenForm").submit((e)=>onsubmit(e)));
		if(form.formtype=="exicting")
			this.renderShareLinks();
	}
	renderShareLinks(){
		$(".exicting").append(
			$("<div>").addClass("shareLinks"));
			this.shareLinks.forEach(link=>{
				$(".shareLinks").append(
					$("<div>").addClass(link.class).append($("<a>",{href:link.href})
						.append($("<i>",{class:link.icon}),$("<p>").text(link.text))))
			})
			$(".swell-share-referral-sms").addClass("show-at-mobile")
			$(".swell-share-referral-copylink").click(this.copyLinkClicked)
	}
	copyLinkClicked(){
		$("body").append(
			$("<div>").addClass("popup-background").append(
			$("<div>").addClass("popup-body").append(
				$("<img>").addClass("popup-close").click(()=>{
					$(".popup-background").remove();}),			
				$("<h3>").text(swellAPI.getCustomerDetails().referralLink),
				$("<input>",{type:"button",value:"Copy Link"})
				.mouseup(()=>{
					$(".popup-body input").css("opacity","1")
				})
				.click(()=>{
					$(".popup-body input").css("opacity",".4")
					navigator.clipboard.writeText(swellAPI.getCustomerDetails().referralLink)}),			
				$("<p>").text("Copy link and share with your friends."))))
	}
	onNextSubmit(e){
		e.preventDefault();
		var userEmail= $(".new input");
		$(".error-email").remove();
		let onSuccess=function(){
			$(".new").removeClass("showForm").addClass("hiddenForm");
			$(".exicting").removeClass("hiddenForm").addClass("showForm");
		}
		let onError=function(){
			$(".refer-form-input").append(
				$("<h4>").text("Your friend is already a fan of Smart Cups!").addClass("error-email"))
		}
		swellAPI.identifyReferrer(userEmail.val(),onSuccess,onError);
	}
	onSendSubmit(e){
		e.preventDefault();
		var friendsEmail=$(".exicting input");
		var mails=friendsEmail.val().split(",");
		$(".error-email").remove();
		let onSuccess=function()
		{
			$(".refer-form").append(
				$("<div>").addClass("refer-mail-send").append(
					$("<h3>").text("Thanks!"),
					$("<hp>").text("A referral email has been successfully sent."),
					$("<p>").text("✕").addClass("refer-mail-send-close").click(()=>{
						$(".refer-mail-send").remove();
					})))
			$(".refer-form-input input[type=text]").val("");
            // $(".history-refer table tbody").empty();
            swellAPI.refreshCustomerDetails();
            // setTimeout(() => {
            // 	new historyRefer(swellAPI.getCustomerDetails().referrals).renderHistoryRefer();
            // }, 1000)
		}
		let onError=function(){
			$(".refer-form-input").append(
				$("<p>").text("Your friend is already a fan of Smart Cups!").addClass("error-email"))
		}
		 swellAPI.sendReferralEmails(mails,onSuccess,onError)
	}
	renderHistoryRefer(referrals){	
		$(".history-refer").removeClass("hidden-history").addClass("show-history")
		$(".referral-wrap").removeClass("withOutHistory").addClass("withHistory")
		$(".img-to-mobile").removeClass("img-to-mobile").addClass("img-to-mobile-with-history")
		referrals.forEach(refer=>{
			$(".history-refer table tbody").append(
				$("<tr>").append(
					$("<td>").append($("<p>").text(refer.email)),
					$("<td>").append($("<p>").text(`${refer.completedAt!==null ? "Purchased" : "Invited"}`))))
		})
	}
	showForm(customer){
		if(customer.email!==undefined){
			$(`.${this.formsRefer.exictingUserForm.formtype}`).removeClass("hiddenForm").addClass("showForm");
		}
		else{
			$(`.${this.formsRefer.newUserForm.formtype}`).removeClass("hiddenForm").addClass("showForm");
		}
	}
}